export default __webpack_public_path__ + "images/3S.a00ab4b.png";